<template>
  <div class="cc-root">

    <div class="cc-bg">
      <div class="cc-bg__overlay"></div>
    </div>

    <div class="cc-page">
      <article class="cc-card">

        <div class="cc-card__bar" aria-hidden="true"></div>

        <div class="cc-card__inner">

          <img class="cc-logo cc-logo--dark" src="@/assets/CruzControl_Logo_Small_Icon.svg" alt="CruzControl" />
          <img class="cc-logo cc-logo--light" src="@/assets/CruzControl_Logo_Small_Icon_Light.svg" alt="CruzControl" />

          <header class="cc-header">
            <h1 class="cc-header__title">GOODBYE</h1>
            <p class="cc-header__sub">Signing you out securely…</p>
          </header>

          <div v-if="submitting" class="cc-loading">
            <LoadingSpinner />
          </div>

        </div>

        <div class="cc-card__foot">
          <span class="cc-card__wordmark">CRUZCONTROL</span>
        </div>

      </article>
    </div>

  </div>
</template>

<script>

import { signOut } from 'aws-amplify/auth';
import LoadingSpinner from "@/components/LoadingSpinner";
import {mapMutations} from "vuex";


export default {
  name: "logoutPage",
  title: "Cruz Control | Logout",
  components: {
    LoadingSpinner
  },
  data() {
    return {
      submitting: false,
      showError: false,
      errorMsg: "",
      noConnection: false,
      accessToken: '',
      email: "",
      password: "",
    }
  },
  methods: {
    ...mapMutations(["setUser", "setAccessToken", "resetState"]),
    async logout() {
      try {
        await signOut();
      } catch (error) {
        console.log('Error signing out:', error);
      } finally {
        // Always clear state and redirect, even if signOut fails
        await this.resetState();
        await this.$router.push('/login');
      }
    }
  },
  mounted() {
    this.logout();
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Big+Shoulders+Display:wght@700;800;900&family=Barlow:wght@300;400;500;600&display=swap');

.cc-root { position: fixed; inset: 0; overflow: hidden; font-family: 'Barlow', sans-serif; }
.cc-bg { position: absolute; inset: 0; z-index: 0; background-color: var(--cc-page); transition: background-color 0.3s; }
.cc-bg__overlay { position: absolute; inset: 0; background: var(--cc-overlay-grad); transition: background 0.3s; }
.cc-page { position: relative; z-index: 10; min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 1.5rem; }

.cc-card { width: 100%; max-width: 430px; background: var(--cc-card); backdrop-filter: blur(28px) saturate(150%); -webkit-backdrop-filter: blur(28px) saturate(150%); border: 1px solid var(--cc-card-border); border-radius: 4px; overflow: hidden; box-shadow: var(--cc-card-shadow); animation: cardIn 0.65s cubic-bezier(0.16, 1, 0.3, 1) both; transition: background 0.3s, border-color 0.3s, box-shadow 0.3s; }
@keyframes cardIn { from { opacity: 0; transform: translateY(22px) scale(0.97); } to { opacity: 1; transform: translateY(0) scale(1); } }
.cc-card__bar { height: 3px; background: linear-gradient(90deg, #0092bf 0%, #00bcf5 55%, #fcef60 100%); }
.cc-card__inner { padding: 2.25rem 2.5rem 2rem; }

.cc-logo { height: 42px; width: auto; display: block; margin-bottom: 1.75rem; }
.cc-logo--light { display: none; }
[data-theme="light"] .cc-logo--dark  { display: none; }
[data-theme="light"] .cc-logo--light { display: block; }

.cc-header { margin-bottom: 0; }
.cc-header__title { font-family: 'Big Shoulders Display', sans-serif; font-size: 3.375rem; font-weight: 900; letter-spacing: 0.04em; color: var(--cc-t1); line-height: 1; margin: 0 0 0.4rem; transition: color 0.3s; }
.cc-header__sub { font-size: 0.8125rem; font-weight: 300; color: var(--cc-t3); letter-spacing: 0.02em; margin: 0; transition: color 0.3s; }

.cc-loading { padding: 1.5rem 0 0; display: flex; justify-content: center; }

.cc-card__foot { margin-top: 2rem; padding: 1rem 2.5rem; border-top: 1px solid var(--cc-card-foot); display: flex; justify-content: center; transition: border-color 0.3s; }
.cc-card__wordmark { font-family: 'Big Shoulders Display', sans-serif; font-size: 0.6875rem; font-weight: 700; letter-spacing: 0.32em; color: var(--cc-t5); user-select: none; transition: color 0.3s; }
</style>